export const _SIZES = {
  _H_TOP_NAV: '75px',
  _MAX_W_PAGE: '1280px',
};

export const SIZES = {
  H_TOP_NAV: _SIZES._H_TOP_NAV,
  MAX_W_PAGE: _SIZES._MAX_W_PAGE,
  H_MAIN_CONTENT: `calc(100vh - ${_SIZES._H_TOP_NAV})`,
};
